<template>
  <div class="text-page">
    <vue-headful :title="doctitle" />
    <div
      class="position-relative"
      style="max-width: 1900px; margin-left: auto; margin-right: auto"
    >
      <b-container style="max-width: 830px">
        <b-row>
          <b-col>
            <h1>Privacy Policy</h1>
            <p>
              We will give your data the same attention, care and respect we
              give you when you attend our conference.
            </p>
            <ul class="m-0">
              <li>
                We promise to collect, use and store your personal data in a
                safe and secure way.
              </li>
              <li>
                We promise to only use your personal data for the specific
                purposes stated.
              </li>
              <li>
                We promise to keep you informed about how we use your
                information and who we give it to.
              </li>
              <li>This page has been updated the 15th of May 2025.</li>
            </ul>

            <DividerPink />

            <h2>Privacy Notice</h2>
            <p class="m-0">
              This privacy notice tells you what to expect when Öredev AB
              collects personal information about you when you use the
              <a
                href="https://oredev.org/"
                target="_blank"
                rel="noopener noreferrer"
                >oredev.org</a
              >
              website and associated sales platform. Öredev AB is committed to
              protecting your personal information when you use Öredev AB
              services. Whenever you provide such information, we will only use
              your information in line with all applicable data protection laws,
              including the General Data Protection Regulation (GDPR). Your
              information will be kept in a secure environment and access to it
              will be restricted according to the
              <a
                href="https://en.wikipedia.org/wiki/Need_to_know"
                target="_blank"
                rel="noopener noreferrer"
                >'need to know'</a
              >
              principle.
            </p>
            <DividerBlue />

            <h2>What information will we collect about you?</h2>
            <p>
              We collect personal data we use for contractual obligation upon
              registration. For those of you that are or have been clients of
              ours, we would like to inform you that if you do NOT wish to keep
              this data in our database, please contact us and we assure you
              that we'll delete them within a time frame specified by the
              relevant laws.
            </p>
            <p class="m-0">
              Öredev AB collects information about how you use
              <a
                href="https://oredev.org/"
                target="_blank"
                rel="noopener noreferrer"
                >oredev.org</a
              >
              via our website and the device(s) that you use to access the
              service. This includes collecting unique online identifiers such
              as IP addresses, which are numbers that uniquely identify a
              specific computer or other network device on the internet. For
              more information, see our section on 'cookies' below.
            </p>

            <DividerGreen />

            <h2>
              How will Øredev AB use the information it collects about me?
            </h2>
            <ul>
              <li>
                Registration, to send you the invoice, print a badge and send
                you info related to the event.
              </li>
            </ul>
            <p>
              The lawful justification for sending marketing communications
              about Öredev AB events and services to you is that you have given
              clear consent for your personal data to be used for this specific
              purpose. You are always in control of your data. You can opt in or
              out of receiving marketing communications during the registration
              process for the Øredev Email Newsletter. You can also unsubscribe
              from Öredev marketing communications by clicking 'Unsubscribe' on
              the footer of a Øredev marketing email.
            </p>
            <p>
              Your information will be handled and used by our trusted
              suppliers. In the list below you can find their privacy and data
              protection policies.
            </p>
            <ul>
              <li>
                <a
                  href="https://www.printhuset.se/om-oss/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Printhuset</a
                >
                : Printing house, they receive a list containing your name,
                surname, company and days of attendance to the conference, i.e.
                all the information needed to print your badge.
              </li>
              <li>
                <a
                  href="https://www.trippus.com/sv/sakerhet"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Trippus</a
                >: Registration and invoicing system, we send them the
                information you agree to leave upon registration.
              </li>
              <li>
                <a
                  href="https://www.topvisible.se/privacy-statement-eu/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Top Visible AB</a
                >: Our trusted communication agency, we send them the
                information you agree to leave upon registration.
              </li>
              <li>
                <a
                  href="https://app.billecta.com/ht/DataProtectionInformation"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Billecta</a
                >: Invoicing system.
              </li>
              <li>
                <a
                  href="https://www.payex.se/dataskydd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >PayEx</a
                >: Credit Card payment system.
              </li>
              <li>
                <a
                  href="https://mailchimp.com/about/security/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Mailchimp</a
                >: We use Mailchimp Pro to send our newsletter. They store Email
                addresses of our participants/customers
              </li>
              <li>
                <a
                  href="https://speaker.travel/trust/privacy.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Speaker.Travel</a
                >: We use Speaker.Travel to book the travel for our speakers.
                Speaker.Travel receive the info the speakers are agreeing to
                leave.
              </li>
              <li>
                <a
                  href="https://www.bestwestern.com/en_US/popup/policy.popups.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Malmö Arena Hotel</a
                >: When you purchase tickets that include hotel accommodation
                through our website, we need to share certain personal
                information with the hotel to facilitate your booking. The hotel
                receiving your information are also expected to handle it
                responsibly and in compliance with their own privacy policies.
              </li>
              <li>
                <a
                  href="https://sessionize.com/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Sessionize</a
                >: We use Sessionize for our Call for Papers.
              </li>
            </ul>
            <p class="m-0">
              We will keep your information within Öredev AB and our trusted
              third parties except where disclosure is required by law, for
              example to government bodies and law enforcement agencies.
            </p>

            <DividerOrange />

            <h2>Electronic badges and lead scanning</h2>
            <p>
              We use badge scanning technology at our events for security
              reasons and to help improve your experience and network
              effectively with our delegates and exhibitors. Everyone attending
              Øredev requires an official, printed badge. The information
              displayed will be provided by you during registration.
            </p>
            <p>
              You'll need to allow us to scan your badge to gain entry on to the
              exhibition floor and other restricted areas. All other badge
              scanning is optional. You do not have to let anyone else scan your
              badge. If you allow an exhibitor to scan your badge, you're giving
              them a copy of some of your registration information: your name,
              email, phone number, company and job title, just as if you were
              handing them a business card.
            </p>
            <p>
              The exhibitor may use this information to contact you after the
              event or for other purposes that you agree with them. The
              exhibitor's use of your information in this situation is subject
              to your direct relationship with the exhibitor and their own
              privacy policies.
            </p>
            <p class="m-0">
              We use Trippus as a supplier for badges and lead scanning
              services. They'll process your information for us, and for the
              exhibitors that you authorise to access your information when they
              scan your badge.
              <a
                href="https://www.trippus.com/sv/trippus-gdpr-ready"
                target="_blank"
                rel="noopener noreferrer"
                >Trippus' Privacy policy</a
              >.
            </p>

            <DividerPink />

            <h2>Photography and Video</h2>
            <p>
              Attending Øredev, you consent to us using photographs and/or video
              recordings including images of you both internally and externally
              to promote the conference. These images could be used in print and
              digital media formats including print publications, websites,
              e-marketing, posters banners, advertising, film, and social media.
            </p>
            <p class="m-0">
              You understand that images on websites can be viewed throughout
              the world and not just in Sweden and that some overseas countries
              may not provide the same level of protection to the rights of
              individuals as EU legislation provides. Some images or recordings
              may be kept permanently once they are published and be kept as an
              archive of Øredev's history.
            </p>

            <DividerBlue />

            <h2>How long will Øredev AB keep my information?</h2>
            <p>
              Your personal details from your registration will be retained for
              a period of three years.
            </p>
            <p class="m-0">
              Your personal details for marketing communications are retained
              until such a time as you tell us that you no longer wish to
              receive marketing messages. We will keep this information about
              you until you tell us otherwise.
            </p>

            <DividerGreen />

            <h2>What rights do I have over my personal data?</h2>
            <p>Under the GDPR, you have the right to:</p>
            <ul class="m-0">
              <li>
                Access your personal data by making a subject access request.
              </li>
              <li>
                Rectification, erasure or restriction of your information where
                this is justified.
              </li>
              <li>
                Object to the processing of your information where this is
                justified.
              </li>
              <li>Data portability.</li>
            </ul>

            <DividerOrange />

            <h2>Privacy and Cookies</h2>
            <p>
              Cookies are small text files which are stored on your computer
              when you visit certain web pages. Some of the cookies we use are
              necessary for some parts of our website to work whilst other
              cookies are used to provide tailored advertising—These cookies are
              used by trusted third parties to deliver adverts more relevant to
              you and your interests.
            </p>
            <p>
              We use Google Analytics to track user behaviour and marketing
              results on our webpage. Your IP-adress is anonymised before it
              gets registered on googles servers. The cookies track what you do
              on our webpage and if you have been there before. We never connect
              the data to any personally identifiable information.
            </p>
            <p>
              But it is definitely not all about marketing at Öredev AB. We use
              cookies to understand how our sites are used which helps us
              improve your overall online experience. They also allow some
              functionality, like making your personal schedule or not having a
              dialog pop up every time you visit us.
            </p>
            <p class="m-0">
              We can see what you are interested in. It helps us achieve our
              vision—building a conference you will like to attend. It also
              helps us determine which speakers should be placed in the biggest
              rooms during the conference.
            </p>

            <DividerPink />

            <h2>Oredev AI policy</h2>
            <p>
              <b>Tech with intention. People at the center.</b><br />
              Øredev is a space where technology meets humanity — with curiosity,
              creativity, and care. As artificial intelligence evolves, we see
              it not as a replacement for human insight, but as a tool to
              support meaningful experiences, critical thinking, and inclusive
              progress.
            </p>
            <p class="m-0">
              <b>How we use AI</b><br />
              At Øredev, AI plays a limited, transparent role in supporting our
              operations and communications:
            </p>
            <ul>
              <li>
                <b>On our website:</b> AI tools may assist with things like
                content drafting, translations, and accessibility. All content
                is reviewed by our team to ensure quality, tone, and truth.
              </li>
              <li>
                <b>Attendee experience:</b> AI may be used for automated
                ticketing support or personalized interactions — always with your
                consent and your privacy protected.
              </li>
              <li>
                <b>Your data:</b> We do not use attendee or speaker data to
                train AI models. Øredev complies fully with GDPR and puts
                people's privacy first.
              </li>
            </ul>
            <p class="m-0">
              <b>Speaker & Contributor Guidelines</b><br />
              We welcome the use of AI in talks, art, and materials — as long as
              it aligns with our values of openness, integrity, and originality.
              If AI has contributed to your work:
            </p>
            <ul class="m-0">
              <li><b>Disclose it.</b> Transparency builds trust.</li>
              <li>
                <b>Own it.</b> You are responsible for the material you present,
                regardless of its source.
              </li>
              <li>
                <b>Challenge it.</b> Øredev is a space to explore — not blindly
                endorse — the tools shaping our world.
              </li>
            </ul>
            <p>
              We do not tolerate the use of AI for deception, plagiarism, or
              manipulation. When in doubt, ask us.
            </p>
            <p class="m-0">
              <b>Our stance on AI</b><br />
              AI is here—and so is our responsibility to question, shape, and
              steward its future. At Øredev, we support:
            </p>
            <ul>
              <li>Ethical, inclusive, and transparent AI development.</li>
              <li>
                Diverse voices in AI conversations, especially those often
                underrepresented.
              </li>
              <li>
                A critical, hopeful approach that blends tech-savviness with
                human empathy.
              </li>
            </ul>
            <p class="m-0">
              Let's build a future where innovation amplifies connection, not
              replaces it.<br />
              Questions or feedback? <a href="mailto:info@oredev.org">Contact us</a>
            </p>

            <DividerBlue />

            <h2>Changes to this privacy notice</h2>
            <p>
              We will keep this privacy notice under regular review and we will
              place any updates here. At the start of this privacy notice, we
              will tell you when it was last updated.
            </p>
            <p>
              <a href="mailto:info@oredev.org">Contact us!</a> If you have
              questions or ideas.... Or just to say Hello!
            </p>
            <p class="m-0">Love and Peace,<br />The Ø Team.</p>

            <DividerGreen />
          </b-col>
        </b-row>
      </b-container>
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/shooting_star_yellow.png"
        class="position-absolute d-none d-xl-block"
        style="top: 2%; left: 4%; max-width: 11%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/pink_planet.png"
        fluid
        class="position-absolute d-none d-xl-block"
        style="top: 17%; right: 0%; max-width: 11%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_blue.png"
        class="position-absolute d-none d-xl-block"
        style="bottom: 59%; left: 6%; max-width: 8%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_orange.png"
        class="position-absolute d-none d-xl-block"
        style="bottom: 40%; right: 3%; max-width: 8%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/planet.png"
        class="position-absolute d-none d-xl-block"
        style="bottom: 30%; left: 2%; max-width: 14%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/eye.png"
        class="position-absolute d-none d-xl-block"
        style="bottom: 5%; right: 3%; max-width: 10%"
        alt=""
        aria-hidden="true"
      />
    </div>
    <!-- Mobile Bottom Images -->
    <b-container
      fluid
      class="position-relative d-sm-none"
      style="height: 175vw; overflow: hidden"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_9.png"
        class="position-absolute"
        style="width: 86vw; left: -10vw; bottom: 88vw"
        alt="A crowd of delegates entering Øredev"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_10.png"
        class="position-absolute"
        style="width: 79vw; right: -5vw; bottom: 7vw"
        alt="A delegate showing a smiling colleague something on his phone"
      />
    </b-container>
    <!-- Desktop Bottom Images -->
    <b-container
      fluid
      class="position-relative d-none d-sm-block"
      style="height: 20vw"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_9.png"
        class="position-absolute"
        style="width: 23vw; left: 4vw; bottom: -4vw"
        alt="A crowd of delegates entering Øredev"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156661/2025/Footer_pages/img_10.png"
        class="position-absolute"
        style="width: 23vw; left: 36vw; bottom: -8vw"
        alt="A delegate showing a smiling colleague something on his phone"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_11.png"
        class="position-absolute"
        style="width: 23vw; left: 64vw; bottom: -3vw"
        alt="A dancer in a costume of green netting"
      />
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Privacy",
  data() {
    return {
      doctitle: "Privacy Policy - " + this.$store.state.conferencename,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/views/Privacy.vue